import { sendQuotesAPI, sendQuoteForReviewAPI } from "api/quotes";
import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";

import {
  sendQuotes,
  sendQuoteForReview,
  setSendingQuotes,
  setSentQuotesError,
  setSentQuotesToken,
} from "store/features/quotesSlice";
import { nextStep } from "store/features/stepperSlice";
import { RootState } from "store/store";

export function* sendQuotesSaga(action) {
  try {
    const response: AxiosResponse<AxiosCommonResponse<SendQuotesResponse>> =
      yield call(sendQuotesAPI, action.payload);
    if (response?.status === 200) {
      if (
        response?.data?.success &&
        response?.data?.errorObject?.message === null
      ) {
        yield put(setSentQuotesToken(response?.data?.results?.token));
      } else if (
        response?.data?.success === false &&
        response?.data?.errorObject?.message !== null
      ) {
        yield put(setSentQuotesError(response?.data?.errorObject?.message));
      }
    }
  } catch (e) {
    console.error(e);
  } finally {
    yield put(setSendingQuotes(false));
  }
}

export function* sendQuoteForReviewSaga(action) {
  try {
    const { externalAuthConfig } = yield select(
      (state: RootState) => state.client
    );
    const response: AxiosResponse<AxiosCommonResponse<SendQuotesResponse>> =
      yield call(sendQuoteForReviewAPI, action.payload);
    if (response?.status === 200) {
      yield put(setSentQuotesToken("token"));
      if (externalAuthConfig?.partner === 'fairfax') {
        yield put(nextStep());
      }
    }
  } catch (e) {
    console.error(e);
  } finally {
    yield put(setSendingQuotes(false));
  }
}

export default function* quotesSaga() {
  yield takeLatest(sendQuotes.type, sendQuotesSaga);
  yield takeLatest(sendQuoteForReview.type, sendQuoteForReviewSaga);
}
